import { useEffect, useRef } from 'react';

const SLIDER_MAX_WIDTH = 1024;

export function useHorizontalMouseScroll() {
  const ref = useRef(null);
  const drag = useRef({ active: false, startX: 0, scrollLeft: 0 });

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const isScrollable = () =>
      window.innerWidth < SLIDER_MAX_WIDTH && el.scrollWidth > el.clientWidth;

    const onWheel = (e) => {
      if (!isScrollable()) return;

      const delta =
        Math.abs(e.deltaX) > Math.abs(e.deltaY) ? e.deltaX : e.deltaY;
      if (delta === 0) return;

      e.preventDefault();
      el.scrollLeft += delta;
    };

    const onMouseDown = (e) => {
      if (!isScrollable() || e.button !== 0) return;

      drag.current = {
        active: true,
        startX: e.clientX,
        scrollLeft: el.scrollLeft,
      };
    };

    const onMouseMove = (e) => {
      if (!drag.current.active) return;
      el.scrollLeft =
        drag.current.scrollLeft - (e.clientX - drag.current.startX);
    };

    const onMouseUp = () => {
      drag.current.active = false;
    };

    el.addEventListener('wheel', onWheel, { passive: false });
    el.addEventListener('mousedown', onMouseDown);
    window.addEventListener('mousemove', onMouseMove);
    window.addEventListener('mouseup', onMouseUp);

    return () => {
      el.removeEventListener('wheel', onWheel);
      el.removeEventListener('mousedown', onMouseDown);
      window.removeEventListener('mousemove', onMouseMove);
      window.removeEventListener('mouseup', onMouseUp);
    };
  }, []);

  return ref;
}
